import View from './View';

export { default as View, getChromecastMiniControllerStyles } from './View';

export default View;
